export const booking = (state) => {
    return state.booking
}